import { Check } from "lucide-react";
import { competencies, technicalSkills } from "../../data/resume";

export const Skills = () => {
  return (
    <section
      id="skills"
      data-testid="skills-section"
      className="py-24 md:py-32 bg-paper"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal max-w-2xl">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-slate-500 mb-4">
            Capabilities
          </p>
          <h2 className="font-serif font-semibold text-ink text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Core competencies & technical skills.
          </h2>
        </div>

        <div className="mt-16 grid lg:grid-cols-12 gap-12">
          {/* Core competencies */}
          <div className="lg:col-span-7 reveal">
            <h3 className="text-sm uppercase tracking-[0.16em] font-semibold text-ink mb-6">
              Core Competencies
            </h3>
            <div className="flex flex-wrap gap-3">
              {competencies.map((c) => (
                <span
                  key={c}
                  data-testid={`competency-${c}`}
                  className="inline-flex items-center gap-2 border border-border bg-white px-4 py-2.5 text-sm text-slatey hover:border-brass hover:text-ink transition-colors"
                >
                  <Check className="h-3.5 w-3.5 text-brass" strokeWidth={2} />
                  {c}
                </span>
              ))}
            </div>
          </div>

          {/* Technical skills */}
          <div className="lg:col-span-5 reveal" style={{ transitionDelay: "0.1s" }}>
            <h3 className="text-sm uppercase tracking-[0.16em] font-semibold text-ink mb-6">
              Technical Skills
            </h3>
            <ul className="border border-border bg-white divide-y divide-border">
              {technicalSkills.map((t) => (
                <li
                  key={t}
                  data-testid={`tech-skill-${t}`}
                  className="flex items-center gap-3 px-5 py-3.5 text-slatey hover:bg-paper transition-colors"
                >
                  <span className="h-1.5 w-1.5 bg-brass shrink-0" />
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
